import {Toast} from "vant";
import Utils from "../utils/Utils";
import field from "./field";

const checkAndToast = (obj, fields) => {
  if(obj && fields)
  {
    for (let dict of fields)
    {
      if(dict)
      {
        if (dict.condikey)
        {
          if (dict.regex)
          {
            if (!Utils.isBlank(obj[dict.condikey]) && obj[dict.condikey] == dict.condivalue && !dict.regex.test(obj[dict.key].trim()))
            {
              Toast(dict.msg);
              return false;
            }
          }
          else
          {
            if (!Utils.isBlank(obj[dict.condikey]) && obj[dict.condikey] == dict.condivalue && Utils.isBlank(obj[dict.key]))
            {
              Toast(dict.msg)
              return false
            }
          }
        }
        else
        {
          if (dict.max) {
            if (obj[dict.key] && obj[dict.key].trim().length > dict.max) {
              Toast(dict.msg)
              return false
            }
          } else if (dict.min) {
            if (!obj[dict.key] || obj[dict.key].trim().length < dict.min) {
              Toast(dict.msg)
              return false
            }
          } else if (dict.regex) {
            if (obj[dict.key] && !dict.regex.test(obj[dict.key].trim())) {
              Toast(dict.msg);
              return false;
            }
          } else {
            if (Utils.isBlank(obj[dict.key])) {
              Toast(dict.msg)
              return false
            }
          }
        }
      }
    }
  }
  return true
}

/**
 * 检查个人信息
 */
const checkResumeInfo = (obj = {}) => {
  if (!checkAndToast(obj, field.info)) {
    return false
  }
  return true
}

/**
 * 检查工作经历
 */
const checkJobList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加工作经历')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let job of list) {
      if (!checkAndToast(job, field.job)) {
        return false
      }
    }
  }
  return true
}

const checkJobListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添加工作经历')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let job of list) {
      if (!checkAndToast(job, field.jobbyAll)) {
        return false
      }
    }
  }
  return true
}

/**
 * 检查教育经历
 */
const checkEduList = (list = []) => {
  //console.log(list)
  if(!list || list.length==0)
  {
    Toast('请添加教育经历')
    return false;
  }
  if(list && list.length>0) {
    for (let edu of list) {
      if (!checkAndToast(edu, field.edu)) {
        return false
      }
    }
  }
  return true
}

const checkEduListbyAll = (list = []) => {
  //console.log(list)
  if (!list || list.length == 0) {
    Toast('请添加教育经历')
    return false;
  }
  if(list && list.length>0) {
    for (let edu of list) {
      if (!checkAndToast(edu, field.edubyAll)) {
        return false
      }
    }
  }
  return true
}


/**
 * 检查项目经历
 */
const checkProList = (list = []) => {
  //console.log(list)
  // if (!list || list.length == 0) {
  //   Toast({ title: '请添加项目经历', icon: 'none' })
  //   return false;
  // }
  if(list && list.length>0) {
    for (let pro of list) {
      if (!checkAndToast(pro, field.pro)) {
        return false
      }
    }
  }
  return true
}

const checkProListbyAll = (list = []) => {
  //console.log(list)
  // if (!list || list.length == 0) {
  //   Toast({ title: '请添加项目经历', icon: 'none' })
  //   return false;
  // }
  if(list && list.length>0) {
    for (let pro of list) {
      if (!checkAndToast(pro, field.probyAll)) {
        return false
      }
    }
  }
  return true
}

/**
 * 检查实习经历
 */
const checkInteList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加实习经历')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.inte)) {
        return false
      }
    }
  }
  return true
}

const checkInteListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添实习作经历')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.intebyAll)) {
        return false
      }
    }
  }
  return true
}

/**
 * 检查作品
 */
const checkWorkList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加作品')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.work)) {
        return false
      }
    }
  }
  return true
}

const checkWorkListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添作品')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.workbyAll)) {
        return false
      }
    }
  }
  return true
}

/**
 * 检查竞赛
 */
const checkContList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加竞赛')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.cont)) {
        return false
      }
    }
  }
  return true
}

const checkContListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添竞赛')
  //   return false;
  // }
  if(list && list.length>0) {
    for (let item of list) {
      if (!checkAndToast(item, field.contbyAll)) {
        return false
      }
    }
  }
  return true
}

/**
 * 检查证书
 */
const checkCertList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加证书')
  //   return false;
  // }
  for (let item of list) {
    if (!checkAndToast(item, field.cert)) {
      return false
    }
  }
  return true
}

const checkCertListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添证书')
  //   return false;
  // }
  for (let item of list) {
    if (!checkAndToast(item, field.certbyAll)) {
      return false
    }
  }
  return true
}

/**
 * 检查语言
 */
const checkLangList = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast('请添加语言')
  //   return false;
  // }
  for (let item of list) {
    if (!checkAndToast(item, field.lang)) {
      return false
    }
  }
  return true
}

const checkLangListbyAll = (list = []) => {
  // if (!list || list.length == 0) {
  //   Toast( '请添语言')
  //   return false;
  // }
  for (let item of list) {
    if (!checkAndToast(item, field.langbyAll)) {
      return false
    }
  }
  return true
}

/**
 * 检查所有字段
 */
const checkAllResume = (resume) => {
  if (!checkAndToast(resume, field.infobyAll)) return false
  if (!checkEduListbyAll(resume.EducationInfo)) return false
  if (!checkInteListbyAll(resume.internshipInfo)) return false
  if (!checkJobListbyAll(resume.ExperienceInfo)) return false
  if (!checkProListbyAll(resume.ProjectInfo)) return false
  if (!checkWorkListbyAll(resume.worksInfo)) return false
  if (!checkContListbyAll(resume.contestInfo)) return false
  if (!checkCertListbyAll(resume.certificateInfo)) return false
  if (!checkLangListbyAll(resume.LanguagesSkills)) return false
  return true
}

export default  {
  checkResumeInfo: checkResumeInfo,
  checkJobList: checkJobList,
  checkEduList: checkEduList,
  checkProList:checkProList,
  checkAllResume: checkAllResume,
  checkInteList:checkInteList,
  checkWorkList:checkWorkList,
  checkContList:checkContList,
  checkCertList:checkCertList,
  checkLangList:checkLangList,
}
